<template>
    <div>
        <h2>{{ title }}</h2>
        <ion-grid class="ion-padding-top">
            <ion-row>
                <ion-col size="10" offset="2">
                    <base-datetime
                        label="Von"
                        v-model="von"
                        id="von"
                    ></base-datetime>
                    <base-datetime
                        label="Bis"
                        v-model="bis"
                        id="bis"
                    ></base-datetime>
                </ion-col>
            </ion-row>
        </ion-grid>
        <div class="ion-text-right">
            <ion-button
                class="-round -add-padding ion-margin-top"
                :disabled="von === '' || bis === ''"
                @click="
                    $emit('change', [
                        {
                            id: 'von',
                            value: von,
                        },
                        {
                            id: 'bis',
                            value: bis,
                        },
                    ])
                "
                >Weiter</ion-button
            >
        </div>
    </div>
</template>

<script>
import BaseDatetime from "@/components/BaseDatetime";

export default {
    components: { BaseDatetime },
    props: {
        title: {
            required: true,
            type: String,
        },
    },
    data() {
        return {
            von: "",
            bis: "",
        };
    },
};
</script>

<style lang="scss" scoped></style>
